import filterproduct1 from "../../../images/productsImages/filterImages/Comercial/sistemaOne/tanqueone.jpg";
import filterproduct2 from "../../../images/productsImages/filterImages/Comercial/sistemaOne/onecambio.jpg";
import filterproduct3 from "../../../images/productsImages/filterImages/Comercial/sistemaOne/CT.jpg";
import filterproduct4 from "../../../images/productsImages/filterImages/Comercial/sistemaOne/purpura.jpg";
import filterproduct5 from "../../../images/productsImages/filterImages/Comercial/sistemaOne/rojo.jpg";
import filterproduct6 from "../../../images/productsImages/filterImages/Comercial/sistemaOne/CT-20-CB.jpg";
import filterproduct7 from "../../../images/productsImages/filterImages/Comercial/sistemaOne/CT-20-CB.jpg";
import filterproduct8 from "../../../images/productsImages/filterImages/Comercial/purificador/UV-F.jpg";
import filterproduct9 from "../../../images/productsImages/filterImages/Comercial/purificador/UV-ML.jpg";
import filterproduct10 from "../../../images/productsImages/filterImages/Comercial/suavizador/suavisador.jpg";
import filterproduct11 from "../../../images/productsImages/filterImages/Comercial/suavizador/tanque.jpg";

import filtercompdf1 from "../../../pdf/filter/FiltradoTanques.pdf";
import filtercompdf2 from "../../../pdf/filter/OneStopPlus.pdf";
import filtercompdf3 from "../../../pdf/filter/FiltradoAzul.pdf";
import filtercompdf4 from "../../../pdf/filter/filtroPurpura.pdf";
import filtercompdf5 from "../../../pdf/filter/FiltradoRojo.pdf";
import filtercompdf6 from "../../../pdf/filter/FiltradoNaranja.pdf";
import filtercompdf7 from "../../../pdf/filter/FiltradoVerde.pdf";
import filtercompdf8 from "../../../pdf/filter/purificador1.pdf";
import filtercompdf9 from "../../../pdf/filter/purificadorF.pdf";
import filtercompdf10 from "../../../pdf/filter/suavizador.pdf";

const filterComercialProductList = [
  {
    _id: "filtcatcomerprod001",
    image: filterproduct1,
    title: "Sistema de filtrado serie ONE",
    code: "",
    category: "Sistemas OneStop",
    brand: "One",
    downLoad: filtercompdf1,
  },
  {
    _id: "filtcatcomerprod002",
    image: filterproduct2,
    title: "Cartucho de repuesto OneStop+",
    code: "",
    category: "Sistemas OneStop",
    brand: "One",
    downLoad: filtercompdf2,
  },
  {
    _id: "filtcatcomerprod003",
    image: filterproduct3,
    title: "Filtro de carbón activado azul 1 1/4”",
    code: "",
    category: "Sistemas OneStop",
    brand: "One",
    downLoad: filtercompdf3,
  },
  {
    _id: "filtcatcomerprod004",
    image: filterproduct4,
    title: "Filtro  polipropileno sedimento purpura",
    code: "",
    category: "Sistemas OneStop",
    brand: "One",
    downLoad: filtercompdf4,
  },
  {
    _id: "filtcatcomerprod005",
    image: filterproduct5,
    title: "Filtro plegado  de carbón activado rojo",
    code: "",
    category: "Sistemas OneStop",
    brand: "One",
    downLoad: filtercompdf5,
  },
  {
    _id: "filtcatcomerprod006",
    image: filterproduct6,
    title: "Filtro plegado sedimento naranja",
    code: "",
    category: "Sistemas OneStop",
    brand: "One",
    downLoad: filtercompdf6,
  },
  {
    _id: "filtcatcomerprod007",
    image: filterproduct7,
    title: "Filtro plegado verde",
    code: "",
    category: "Sistemas OneStop",
    brand: "One",
    downLoad: filtercompdf7,
  },
  {
    _id: "filtcatcomerprod008",
    image: filterproduct8,
    title: "Purificador UV-F",
    code: "",
    category: "Purificador",
    brand: "Hidrotermal",
    downLoad: filtercompdf8,
  },
  {
    _id: "filtcatcomerprod009",
    image: filterproduct9,
    title: "Purificador UV-ML",
    code: "",
    category: "Purificador",
    brand: "Hidrotermal",
    downLoad: filtercompdf9,
  },
  {
    _id: "filtcatcomerprod010",
    image: filterproduct10,
    title: "Filtro suavizador con válvula automática",
    code: "",
    category: "Suavizador",
    brand: "Hidrotermal",
    downLoad: filtercompdf10,
  },
  {
    _id: "filtcatcomerprod011",
    image: filterproduct11,
    title: "Tanque para suavizador",
    code: "",
    category: "Suavizador",
    brand: "Hidrotermal",
    downLoad: "none",
  },
];

export default filterComercialProductList;
